function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGrayAlt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  },
  viewBox: "0 0 100 100"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m30.91 76.739-9.376-28.054a2.913 2.913 0 0 1 4.972-2.822l9.356 10.898L74.68 26.345a2.747 2.747 0 0 1 3.667.251l.363.37a2.744 2.744 0 0 1 .123 3.7L38.448 78.101a4.13 4.13 0 0 1-3.155 1.461h-.455a4.12 4.12 0 0 1-3.928-2.823",
  style: {
    fill: "#c4c0cf",
    fillRule: "nonzero"
  }
}));
export default SvgGrayAlt;